import React from 'react'
import { styled } from '@mui/material'
import { ImageGridImageProps } from './type'
import { ImageField } from '../fields'

const ImageFieldStyled = styled(ImageField)(() => ({
  height: 200,
  width: '100%',
  overflow: 'hidden',
  '& .RaImageField-image': {
    margin: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))

export const ImageGridImage: React.FC<ImageGridImageProps> = ({ source, ...props }) => {
  return <ImageFieldStyled source={source} {...props} />
}
